module.exports = __webpack_public_path__ + "static/media/koffie.db81f521.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/koffie.png
// module id = 337
// module chunks = 0